import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Card = styled(Box)(({ theme }) => ({
  flex: '1 1 0',
  minWidth: '200px',
  padding: '18px 20px',
  borderRadius: '10px',
  backgroundColor: '#FFFFFF',
  border: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
}));

export const TitleRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  color: theme.palette.text.secondary,
  fontSize: '12px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
}));

export const Value = styled(Typography)(({ theme }) => ({
  fontSize: '32px',
  fontWeight: 700,
  color: theme.palette.text.primary,
  lineHeight: 1,
}));

const DELTA_COLOR = {
  good: '#1E6630',
  bad: '#B71C1C',
  neutral: '#666',
} as const;

export const DeltaRow = styled(Box)<{ tone: 'good' | 'bad' | 'neutral' }>(
  ({ tone }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    fontWeight: 600,
    color: DELTA_COLOR[tone],
    '& .material-symbols-outlined': { fontSize: '16px' },
  })
);
